import { connect } from 'react-redux';
import ViewUploadedDocuments from "./ViewUploadedDocuments";
import { bindActionCreators } from 'redux';
import {
    siteRepository,
    getSiteRepository
} from 'services/redux/installation/siteListing/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
const mapStateToProps = (state) => ({
    getSiteRepositoryDetails: state.siteListingReducer.siteRepository,
    createSiteRepository: state.siteListingReducer.createSiteRepository,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            siteRepository,
            getSiteRepository
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(ViewUploadedDocuments);